import { showNotification } from '@/helper/helper';
import axios from 'axios';

const url = process.env.VUE_APP_URL;
delete axios.defaults.headers.common['Authorization'];

export const registerUser = async (userData) => {
    delete axios.defaults.headers.common['Authorization'];
    return await axios.post(url + '/register/', userData);
};

export const loginUser = async (userData) => {
    delete axios.defaults.headers.common['Authorization'];
    return await axios.post(url + '/api-token-auth/', userData);
};

export const logoutUser = async () => {
    return await axios.get(url + '/api-token-logout/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const resetPasswordMail = async (email) => {
    delete axios.defaults.headers.common['Authorization'];
    return await axios.post(url + '/password_reset/', { email });
};

export const resetPassword = async (password, token) => {
    delete axios.defaults.headers.common['Authorization'];
    return await axios.post(url + '/password_reset/confirm/', { password, token })
        .catch(e => showNotification('error', e.response));
};

export const blockUser = async (userId) => {
    return await axios.patch(url + '/user/block/' + userId + '/', {},
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        }
    ).catch(e => showNotification('error', e.response));
};

export const getBlackList = async () => {
    return await axios.get(url + '/users-blocked/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getUsers = async (pageNum, search = null) => {
    const path = url + '/user/all/' + ('?page=' + pageNum) + (search ? '&search=' + search : '');

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getUsersParams = async (params) => {
    const path = url + '/user/all/' + params;

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getGroupList = async () => {
    return await axios.get(url + '/group-list/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const createUser = async (data) => {
    return await axios.post(url + '/register/user/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getProfile = async (userId) => {
    return await axios.get(url + '/user/profile/' + userId + '/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const updateProfile = async (data) => {
    return await axios.patch(url + '/user/profile/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const updateUserInfo = async (userId, data) => {
    return await axios.patch(url + '/user/profile/' + userId + '/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const updatePassword = async (data) => {
    return await axios.patch(url + '/user/profile/password/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getHrs = async () => {
    return await axios.get(url + '/user/hr/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const sendMessageToRoles = async (data) => {
    return await axios.post(url + '/user/send-message/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getRoles = async () => {
    return await axios.get(url + '/user/send-message/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getNotificationsCount = async () => {
    return await axios.get(url + '/doc/notifications/count', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const registerUserByEmail = async (link) => {
    return await axios.get(url + link).catch(e => showNotification('error', e.response));
};

export const activateUser = async (userId) => {
    return await axios.patch(url + '/user/activate/' + userId + '/', {},
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        }
    ).catch(e => showNotification('error', e.response));
};

export const loginAsUser = async (userId) => {
    return await axios.post(url + '/admin/login-as-user/', { user_id: userId },
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        }
    ).catch(e => showNotification('error', e.response));
};

export const getUsersReport = async (type) => {
    return await axios.get(url + '/user/report/?report_type=' + type, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        },
        responseType: 'blob'
    }).catch(e => showNotification('error', e.response));
};